import React from 'react';
import { Link } from 'react-router-dom';
import s from './Shop.scss';

const Shop = ({ shop }) => (
	<div className={s.shop}>
		{
			shop.map((item, i) => {
				const itemStyles = {};
				const isMobileDivider = window.innerWidth <= 600 ? 0.5 : 1;
				if (item.marginTop) itemStyles.marginTop = `${parseInt(item.marginTop, 10) * isMobileDivider}px`;
				if (item.marginBottom) itemStyles.marginBottom = `${parseInt(item.marginBottom, 10) * isMobileDivider}px`;

				return (
					<div key={i} className={s.shop_item} style={itemStyles}>
						{
							item.sectionComponent.map((section) => {
								const SectionWrapper = section.link ? Link : 'div';
								const sectionAttrs = {};
								if (section.link) sectionAttrs.to = section.link;
								sectionAttrs.key = section.image.url || section.video.url;
								sectionAttrs.style = {
									gridRow: `${section.row} / span ${section.rowHeight}`,
									gridColumn: `${section.column} / span ${section.columnWidth}`,
								};

								return (
									<SectionWrapper {...sectionAttrs} className={s.shop_item_media}>
										{
											section.image ? <img className={s.shop_item_media_image} src={section.image.url} alt={section.image.alt} /> : null
										}
										{
											section.video ? <video className={s.shop_item_media_video} src={section.video.url} autoPlay={section.video.autoplay} playsInline muted={section.video.mute ? 1 : null} loop={section.video.loop} /> : null
										}
									</SectionWrapper>
								);
							})
						}
					</div>
				);
			})
		}
	</div>
);

export default Shop;



// WEBPACK FOOTER //
// ./components/Shop/Shop.jsx